import React, { useState } from 'react';
import { withRouter } from 'react-router';
import Doc from '../components/documentClient/Doc';
import Sidebar from '../components/layout/sidebar/Sidebar';

function doc() {
	return (
		<div className='docPageClient'>
			<Sidebar />
			<Doc style={{ marginLeft: '270px' }} />
		</div>
	);
}

export default withRouter(doc);
